import { ReactElement } from 'react'
import { GridValidRowModel } from '@mui/x-data-grid-premium'
import {
	FetchQueryRequest,
	SearchFilterExperience,
	SearchFilterExperienceProps,
	UseFetchFilterOptionsQuery,
} from '@equipmentshare/dcf-search-filter-experience'

export type SearchFilterGridProps<Row extends GridValidRowModel, Req extends FetchQueryRequest> =
	Omit<SearchFilterExperienceProps<Row, Req>, 'filters' | 'useFetchFilterOptionsQuery'>
	& Partial<Pick<SearchFilterExperienceProps<Row, Req>, 'filters' | 'useFetchFilterOptionsQuery'>>

const useNoFilterOptions: UseFetchFilterOptionsQuery<FetchQueryRequest> = () => (
	{ isFetching: false, data: { filterOptions: [] } }
)

export default function SearchFilterGrid<Row extends GridValidRowModel, Req extends FetchQueryRequest>( {
	filters = [],
	useFetchFilterOptionsQuery = useNoFilterOptions,
	// Our options hooks don't compute facet counts, so every option would read "0".
	hideOptionCounts = true,
	...props
}: SearchFilterGridProps<Row, Req> ): ReactElement {
	return (
		<SearchFilterExperience<Row, Req>
			{...props as SearchFilterExperienceProps<Row, Req>}
			filters={filters}
			useFetchFilterOptionsQuery={useFetchFilterOptionsQuery}
			hideOptionCounts={hideOptionCounts}
		/>
	)
}
